/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import Head from 'next/head';
import styled from 'styled-components';
import {UpdatedDate, Wrapper} from '@/components/terms/styles';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    a: "a",
    h2: "h2"
  }, _provideComponents(), props.components);
  return _jsxs(Wrapper, {
    children: [_jsx(_components.h1, {
      children: "Calm Gift Card Terms and Conditions"
    }), _jsx(UpdatedDate, {
      children: "Last Updated: November 7, 2024"
    }), _jsxs(_components.p, {
      children: ["These Gift Card Terms and Conditions (“Terms”) apply to any purchase or use of a physical or virtual Calm gift card, gift subscription, subscription card, or gift certificate (each a “Gift Card”) and are in addition and subject to our ", _jsx(_components.a, {
        href: "https://www.calm.com/terms",
        children: "Terms of Service"
      }), " and ", _jsx(_components.a, {
        href: "http://calm.com/privacy",
        children: "Privacy Policy"
      }), " that govern your use of the Services. Any capitalized terms used but not defined herein shall have the meaning given in the Terms of Service and/or Privacy Policy. By purchasing, accepting, or redeeming a Gift Card, you agree to these Terms."]
    }), _jsxs(_components.p, {
      children: ["For additional terms and conditions related to Gift Cards issued by Blackhawk Network Inc. and/or Pathward N.A., as indicated on the back of the respective Gift Card (i.e., for cards starting with 603953), visit the ", _jsx(_components.a, {
        href: "https://blackhawknetwork.com/card-order-agreement",
        children: "Blackhawk Network Card Order Agreement"
      }), "."]
    }), _jsxs(_components.p, {
      children: ["If you have any questions about your Gift Card or these Terms, ", _jsx(_components.a, {
        href: "http://www.calm.com/contact-us",
        children: "please contact us"
      }), "."]
    }), _jsx(_components.h2, {
      children: "Purchase, Redemption, and Eligible Subscriptions"
    }), _jsx(_components.p, {
      children: "Calm Gift Cards constitute pre-paid subscriptions to access Calm Premium. Gift Cards may be offered in various denominations, including but not limited to 3-month, 6-month, 1-year, and lifetime subscriptions. Gift Cards are not valid on any other Calm products or services. After a Gift Card is purchased, the value cannot be increased."
    }), _jsx(_components.p, {
      children: "The value of the Gift Card cannot be added to an existing subscription that is currently billed through Calm or a third-party subscription provider (e.g., the App Store or Google Play). If you have an active subscription to Calm Premium, you will need to allow that subscription to expire before you redeem your Gift Card."
    }), _jsxs(_components.p, {
      children: ["To redeem the Gift Card, visit ", _jsx(_components.a, {
        href: "https://www.calm.com/redeem",
        children: "www.calm.com/redeem"
      }), " and sign into your Account. If you do not have an Account, you must create one before redeeming your Gift Card. You will be able to enter the redemption code on the Gift Card once you log into your Account."]
    }), _jsx(_components.p, {
      children: "After successfully redeeming your Gift Card, the entire value of the Gift Card will be credited to your Account. When the length of the subscription term ends, the subscription will terminate unless you provide a valid payment method. You may only add one Gift Card to your Account at a time. Once you have redeemed a Gift Card, you must wait until the subscription has expired to redeem another Gift Card."
    }), _jsx(_components.h2, {
      children: "No Cash Refunds, Exchanges, or Resale"
    }), _jsx(_components.p, {
      children: "Calm Gift Cards are not refundable or redeemable for cash unless otherwise required by applicable law. Sales tax may be applied. Once a Gift Card has been redeemed, the subscription may not be transferred or assigned to another person or Account. Calm Gift Cards cannot be reloaded or resold, and any Gift Card that has been resold is subject to invalidation at Calm's sole discretion."
    }), _jsx(_components.h2, {
      children: "Expiration and Risk of Loss"
    }), _jsx(_components.p, {
      children: "Unless otherwise specified, Gift Cards do not expire. Please keep your Gift Card and the code in a safe location. Calm is not responsible for lost, stolen, or unauthorized use of Gift Cards."
    }), _jsx(_components.h2, {
      children: "Restrictions"
    }), _jsx(_components.p, {
      children: "Use of Calm Gift Cards in connection with any advertising, marketing, or promotion, or in any manner to suggest or imply that any person, product, or service is associated with or sponsored by Calm is expressly prohibited without Calm's prior written consent."
    }), _jsx(_components.h2, {
      children: "Modifications of These Terms"
    }), _jsx(_components.p, {
      children: "Calm reserves the right to amend, modify, or waive any of these Terms at any time in its sole discretion. The most current version of these Terms will be published on this website and will supersede all prior versions of these Terms."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
